<template>
    <div>
        <card-header title="Transactions" icon="fa-usd-circle"/>

        <card-body>
            <card-list>
                <subheader-list-item icon="fa-calendar" title="Date Range"/>

                <container-list-item padded no-border>
                    <div class="columns">
                        <div class="column">
                            <b-field label="Start Date" label-position="inside">
                                <b-datepicker
                                    v-model="filters.startDate"
                                    placeholder="Select start date"
                                    icon="calendar"
                                    :max-date="filters.endDate || new Date()"
                                />
                            </b-field>
                        </div>
                    </div>

                    <div class="columns">
                        <div class="column">
                            <b-field label="End Date" label-position="inside">
                                <b-datepicker
                                    v-model="filters.endDate"
                                    placeholder="Select end date"
                                    icon="calendar"
                                    :min-date="filters.startDate"
                                    :max-date="new Date()"
                                />
                            </b-field>
                        </div>
                    </div>

                    <div class="columns">
                        <div class="column">
                            <div class="date-shortcuts">
                                <a @click="setThisMonth">This Month</a>,
                                <a @click="setLastMonth">Last Month</a>,
                                <a @click="setThisYear">This Year</a>,
                                <a @click="setLastYear">Last Year</a>
                            </div>
                        </div>
                    </div>
                </container-list-item>

                <subheader-list-item icon="fa-list-check" title="Transaction Types"/>

                <container-list-item padded no-border>
                    <div class="columns">
                        <div class="column">
                            <b-field>
                                <b-switch v-model="filters.enrollment">Course Enrollments</b-switch>
                            </b-field>
                            <b-field>
                                <b-switch v-model="filters.resellerCart">Reseller Cart Enrollments</b-switch>
                            </b-field>
                            <b-field>
                                <b-switch v-model="filters.registration">Conference Registrations</b-switch>
                            </b-field>
                            <b-field>
                                <b-switch v-model="filters.courseApplication">Course Application Fees</b-switch>
                            </b-field>
                            <b-field>
                                <b-switch v-model="filters.confApplication">Conference Application Fees</b-switch>
                            </b-field>
                            <b-field>
                                <b-switch v-model="filters.planTaxes">Payment Plan Taxes</b-switch>
                            </b-field>
                            <b-field>
                                <b-switch v-model="filters.other">Other (Cart, Reactivation, etc.)</b-switch>
                            </b-field>
                        </div>
                    </div>
                </container-list-item>
            </card-list>
        </card-body>

        <card-footer class="pt-3 pb-3">
            <div class="columns">
                <div class="column has-text-right">
                    <b-button
                        type="is-info"
                        size="is-small"
                        @click="viewTransactions"
                    ><i class="fas fa-eye mr-2"></i>View Transactions
                    </b-button>
                </div>
            </div>
        </card-footer>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardList from "@/TIER/components/CardList";
    import CardFooter from "@/TIER/components/CardFooter";
    import SubheaderListItem from "@/TIER/components/SubheaderListItem";
    import ContainerListItem from "@/TIER/components/ContainerListItem";
    import moment from "moment";

    export default {
        components: {
            CardHeader,
            CardBody,
            CardList,
            CardFooter,
            SubheaderListItem,
            ContainerListItem
        },
        props: ['card', 'child'],
        data() {
            return {
                filters: {
                    startDate: moment().startOf('month').toDate(),
                    endDate: new Date(),
                    enrollment: true,
                    resellerCart: true,
                    registration: true,
                    courseApplication: true,
                    confApplication: true,
                    planTaxes: true,
                    other: true
                }
            }
        },
        computed: {
            selectedTransactionTypes() {
                const types = [];
                if (this.filters.enrollment) types.push('enrollment');
                if (this.filters.resellerCart) types.push('reseller_cart');
                if (this.filters.registration) types.push('registration');
                if (this.filters.courseApplication) types.push('course_application');
                if (this.filters.confApplication) types.push('conf_application');
                if (this.filters.planTaxes) types.push('plan_taxes');
                if (this.filters.other) {
                    types.push('cart');
                    types.push('reactivation');
                    types.push('other');
                }
                return types;
            }
        },
        mounted() {
            this.$emit('loading', false);
        },
        methods: {
            setThisMonth() {
                this.filters.startDate = moment().startOf('month').toDate();
                this.filters.endDate = moment().endOf('month').toDate();
            },

            setLastMonth() {
                this.filters.startDate = moment().subtract(1, 'month').startOf('month').toDate();
                this.filters.endDate = moment().subtract(1, 'month').endOf('month').toDate();
            },

            setThisYear() {
                this.filters.startDate = moment().startOf('year').toDate();
                this.filters.endDate = moment().endOf('year').toDate();
            },

            setLastYear() {
                this.filters.startDate = moment().subtract(1, 'year').startOf('year').toDate();
                this.filters.endDate = moment().subtract(1, 'year').endOf('year').toDate();
            },

            viewTransactions() {
                // Pass transaction types as pipe-separated string (card system uses commas)
                this.$openCard('transactions-list', {
                    startDate: this.filters.startDate ? moment(this.filters.startDate).format('YYYY-MM-DD') : null,
                    endDate: this.filters.endDate ? moment(this.filters.endDate).format('YYYY-MM-DD') : null,
                    transactionTypes: this.selectedTransactionTypes.join('|')
                }, this.card);
            }
        }
    }
</script>

<style lang="scss" scoped>
    .date-shortcuts {
        font-size: 0.85rem;
        color: #7a7a7a;

        a {
            color: #264d73;
            cursor: pointer;
            text-decoration: none;

            &:hover {
                text-decoration: underline;
            }
        }
    }
</style>
